import { render, staticRenderFns } from "./GameLogModal.vue?vue&type=template&id=642e8348&scoped=true"
import script from "./GameLogModal.vue?vue&type=script&lang=js"
export * from "./GameLogModal.vue?vue&type=script&lang=js"
import style0 from "./GameLogModal.vue?vue&type=style&index=0&id=642e8348&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "642e8348",
  null
  
)

export default component.exports